import { PrerequisiteLoadingService } from "./prerequisite-loading-service";
import app from "../../sdAppModule";

app.service("prerequisiteLoadingService", PrerequisiteLoadingService);
